import useStyles from 'isomorphic-style-loader/useStyles';
import { Label } from 'semantic-ui-react';

import { CommandPaletteListbox } from '../command-palette/command-palette-listbox';

import VulnerabilitySearchResultItem from './vulnerability-search-result-item';
import type { VulnerabilityLookupItem } from './vulnerability-search.models';
import s from './vulnerability-search-result-list.scss';

export interface VulnerabilitySearchResultListProps {
  activeIndex: number;
  listboxId: string;
  onActivate: (index: number) => void;
  onSelect: () => void;
  query: string;
  vulnerabilities: VulnerabilityLookupItem[];
}

/**
 * Advisory result list: the searched advisory id with a CVE count, above a
 * keyboard-navigable listbox of the matched CVEs.
 */
export const VulnerabilitySearchResultList = ({
  activeIndex,
  listboxId,
  onActivate,
  onSelect,
  query,
  vulnerabilities,
}: VulnerabilitySearchResultListProps) => {
  useStyles(s);

  const count = vulnerabilities.length;

  // Prefer the canonical alias from the response over the raw query, which may
  // be lowercased or padded (the lookup accepts either).
  const advisoryId = vulnerabilities[0]?.alsoKnownAs ?? query;

  return (
    <div className={s.results}>
      <div className={s.header}>
        <span className={s.query}>{advisoryId}</span>
        <Label className={s.countChip}>
          {count} {count === 1 ? 'CVE' : 'CVEs'}
        </Label>
      </div>

      <CommandPaletteListbox
        activeIndex={activeIndex}
        ariaLabel={`CVEs for ${advisoryId}`}
        items={vulnerabilities}
        listboxId={listboxId}
        renderItem={(vulnerability, meta) => (
          <VulnerabilitySearchResultItem
            key={vulnerability.vulnerabilityId}
            active={meta.active}
            id={meta.id}
            onActivate={() => onActivate(meta.index)}
            onSelect={onSelect}
            vulnerability={vulnerability}
          />
        )}
      />
    </div>
  );
};

export default VulnerabilitySearchResultList;
